<app-notices-filter #filter [key]="NOTICES_KEY" absolute></app-notices-filter>

<app-layout preset="data">
  <app-layout-title>{{ 'HISTORY.RECONCILIATION.notice_log' | translate }}</app-layout-title>

  <app-layout-content>

    <app-list class="grid" [filterSource]="filter">
      <app-list-container *app-list-paginated-provider="let notice of dataSource">
        <app-list-head>
          <div class="status">
            @switch (notice.status) {
              @case ('PENDING') {
                <mat-icon class="rotation" [matTooltip]="'CLAIM_STATES.in_process' | translate">autorenew</mat-icon>
              }
              @case ('SENT') {
                <mat-icon [matTooltip]="'SENDING_STATUS.sent' | translate" color="primary">check_circle_outlined</mat-icon>
              }
              @case ('ERROR') {
                <mat-icon [matTooltip]="'SENDING_STATUS.error' | translate" color="warn">highlight_off</mat-icon>
              }
            }
          </div>

          <app-date icon="created" [date]="notice.createdAt" [tooltip]="'COLUMNS.create' | translate"></app-date>
        </app-list-head>

        <app-list-body>
          @if (notice.subject) {
            <div>
              <span class="muted">{{ 'HISTORY.RECONCILIATION.mail_subject' | translate }} </span> {{ notice.subject }}
            </div>
          }

          <div class="recipient">
            <img [src]="'assets/svg/' + (notice.recipient.type | lowercase) + '.svg'">

            <app-heading [title]="notice.recipient.contact"
              [subtitle]="getContactLabel(notice.recipient) | async">
            </app-heading>
          </div>
        </app-list-body>

        <app-list-actions>
          <div>
            <a [project-route]="['setting/notices', notice.triggerId]" [matTooltip]="'HISTORY.RECONCILIATION.open_notice' | translate"
              color="primary" mat-icon-button>
              <mat-icon>edit</mat-icon>
            </a>

            <a [project-route]="['history/notices-log', notice.id]"
              [matTooltip]="'HISTORY.RECONCILIATION.notice_info' | translate"
              color="primary"
              mat-icon-button>
              <mat-icon>info_outlined</mat-icon>
            </a>
          </div>

          <app-date [date]="notice.updatedAt" icon="updated" [tooltip]="'COLUMNS.update' | translate"></app-date>
        </app-list-actions>
      </app-list-container>
    </app-list>

  </app-layout-content>
</app-layout>
